// @flow

import type { StackProps } from "@chakra-ui/react";

export const container: StackProps = {
  alignItems: "start",
  width: "100%",
  gridGap: "40px",
};
